import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/configuration/setup/store';

interface TriggerRect {
    top: number;
    left: number;
    width: number;
    height: number;
}

interface MfePopoverPayload {
    iFrameId: string;
    title: string;
    html: string;
    triggerRect: TriggerRect;
}

interface MfePopoverState {
    isOpen: boolean;
    iFrameId: string;
    title: string | null;
    html: string | null;
    triggerRect: TriggerRect | null;
}

const initialState: MfePopoverState = {
    isOpen: false,
    iFrameId: '',
    title: null,
    html: null,
    triggerRect: null,
};

const mfePopoverSlice = createSlice({
    name: 'mfePopover',
    initialState,
    reducers: {
        showMfePopover: (state, action: PayloadAction<MfePopoverPayload>) => {
            state.isOpen = true;
            state.iFrameId = action.payload.iFrameId;
            state.title = action.payload.title;
            state.html = action.payload.html;
            state.triggerRect = action.payload.triggerRect;
        },
        hideMfePopover: (state) => {
            state.isOpen = false;
            state.iFrameId = '';
            state.title = null;
            state.html = null;
            state.triggerRect = null;
        },
    },
});

// Actions
export const { showMfePopover, hideMfePopover } = mfePopoverSlice.actions;

// Selectors
export const getMfePopover = (state: RootState) => state.mfePopover;

export default mfePopoverSlice.reducer;
